const ReassuranceBar = ({ items }) => {
  return (
    <section id="trust" className="py-12 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-2 gap-6 md:gap-8 ${items.length === 5 ? "md:grid-cols-5" : "md:grid-cols-4"}`}>
          {items.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-4 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
              data-testid={`reassurance-item-${index}`}
            >
              <div className="w-14 h-14 bg-amber-50 rounded-2xl flex items-center justify-center mb-4">
                <item.icon className="w-7 h-7 text-amber-600" />
              </div>
              <h3 className="font-heading font-semibold text-slate-900 mb-1 text-sm sm:text-base">
                {item.text}
              </h3>
              <p className="text-xs sm:text-sm text-slate-500">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReassuranceBar;
